<template>
    <div class="form-login">
        <div v-if="loginFailed" class="alert">
            <div class="alert-info">
                <svg xmlns="http://www.w3.org/2000/svg" height="2rem" width="2rem" viewBox="0 0 512 512">
                    <path fill="#dc3545"
                        d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" />
                </svg>
                <p>
                    Could not authenticate you from Ldapmain because "Invalid credentials for {{ invalidUsername }}".
                </p>
            </div>
            <a @click="closeWarning"><svg xmlns="http://www.w3.org/2000/svg" height="1rem" width="1rem"
                    viewBox="0 0 384 512">
                    <path fill="#424242"
                        d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                </svg></a>
        </div>
        <h2>LDAP Login</h2>
        <form @submit.prevent="login">
            <div>
                <label for="username">Username</label>
                <input type="text" id="username" v-model="user" required>
            </div>
            <div>
                <label for="password">Password</label>
                <input type="password" id="password" v-model="password" required>
            </div>
            <button type="submit">Login</button>
        </form>
    </div>
</template>

<script>
import apiService from '@/service';
import { authState } from '../authState'; // Import the global state

export default {
    name: "LoginComponent",
    data() {
        return {
            user: '',
            password: '',
            loginFailed: false,
            invalidUsername: '',
        };
    },
    mounted() {
        if (localStorage.getItem("isLoggedIn") === "true") {
            this.$router.push('/calendar');
            return;
        }
    },
    methods: {
        login() {
            apiService.post(`/User/Login`, {
                user: this.user,
                password: this.password
            })
                .then(response => {
                    this.loginFailed = false;
                    localStorage.setItem('isLoggedIn', 'true');
                    localStorage.setItem('userData', JSON.stringify(response.data));
                    localStorage.setItem('userName', this.user);
                    authState.isLoggedIn = true;
                    this.$router.push('/calendar');
                })
                .catch(error => {
                    console.error('Anmeldung fehlgeschlagen:', error);
                    this.loginFailed = true;
                    this.invalidUsername = this.user;
                })
                .finally(() => {
                });

        },
        closeWarning() {
            this.loginFailed = false;
        }
    },
};
</script>
<style>
.alert {
    background-color: #dc354618;
    width: 150%;
    padding: 1rem;
    border-radius: 5px;
    font-size: 0.75rem;
    align-self: center;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.alert-info {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.form-login {
    margin: auto;
    width: 30%;
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.form-login h2 {
    text-align: center;
    font-size: 2rem;
    margin-bottom: 1rem;
}

.form-login form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.form-login label,
.form-login input {
    display: block;
    width: 100%;
}

.form-login input,
.form-login button {
    padding: .5rem .75rem;
}

.form-login label {
    margin-bottom: .5rem;
    font-weight: 600
}

.form-login input:focus-visible {
    outline: 3px solid #5b97d484;
    border-radius: 2px;
}

.form-login button {
    border: none;
    background-color: #4d4d4d;
    border-radius: 5px;
    font-size: 1rem;
    color: white;
    font-weight: 600;
}

.form-login button:hover {
    cursor: pointer;
    background-color: #c0c0c0;
}
</style>